import api from "../services/api"
import { toast } from "react-toastify"

const getAllCreditCardsByAccount = async () => {
    try {
        const response = await api.get("/transactions/credit-cards")
        const creditCards = response?.data?.data
        return creditCards || []
    } catch (err) {
        toast.error(err?.response?.data?.message)
        return []
    }
}

const getSetupIntentByAccount = async () => {
    try {
        const response = await api.get("/transactions/setup-intent")
        const setupIntent = response?.data?.data
        return setupIntent || {}
    } catch (err) {
        toast.error(err?.response?.data?.message)
        return {}
    }
}

const addPaymentMethodByAccount = async (payment_method_id) => {
    try {
        const response = await api.post("/transactions/payment-method", { payment_method_id })
        return response?.data?.data
    } catch (err) {
        throw err
    }
}

const setDefaultCreditCardByAccount = async (card_id) => {
    try {
        const response = await api.patch(`/transactions/credit-cards/${card_id}/default`)
        return response?.data
    } catch (err) {
        throw err
    }
}

const deleteCreditCardByAccount = async (card_id) => {
    try {
        const response = await api.delete(`/transactions/credit-cards/${card_id}`)
        return response?.data
    } catch (err) {
        throw err
    }
}

export { getAllCreditCardsByAccount, getSetupIntentByAccount, addPaymentMethodByAccount, setDefaultCreditCardByAccount, deleteCreditCardByAccount }
